export default (search = '') => {
  let values = {};

  if (search.length >= 4) {
    values = search
      .substring(1)
      .split('&')
      .reduce((params, next) => {
        const pair = next.split('=');
        params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]); // eslint-disable-line

        return params;
      }, {});
  }
  return values;
};
